/**
 * A forma do resumo do painel (ISSUE-210).
 *
 * **OS TRÊS CAMPOS ANULÁVEIS SÃO O CONTRATO INTEIRO.** `null` neles significa
 * *não há base para o número* — e nunca zero. Confundir os dois é o defeito que
 * esta entrega existe para matar.
 */
import { z } from 'zod'

export const execucaoRecenteSchema = z.object({
  id: z.string().uuid(),
  agente: z.string(),
  /** Valor cru do enum: pending, running, success, failed, cancelled. */
  status: z.string(),
  em: z.string(),
  tokens: z.number().nullable().optional(),
})

export const agenteMaisUsadoSchema = z.object({
  agente_id: z.string().uuid(),
  agente: z.string(),
  execucoes: z.number(),
  /** `null` = denominador zero: nada terminou ainda. NÃO é 0%. */
  taxa_de_sucesso: z.number().nullable(),
})

export const contagemSchema = z.object({
  total: z.number(),
  /** `null` = NÃO HÁ PERÍODO ANTERIOR. `0` = houve, e foi igual. */
  variacao: z.number().nullable(),
})

/**
 * Um total e quantos dele NASCERAM na janela de 7 dias.
 *
 * **NÃO É VARIAÇÃO, E POR ISSO TEM SCHEMA PRÓPRIO.** Agentes e workflows não
 * guardam quantos existiam há uma semana: quem é apagado sai da tabela. O
 * servidor mandava `variacao` nestes dois cartões, e ela era incapaz de ser
 * negativa — semana de queda aparecia como estabilidade. Achado na revisão.
 */
export const contagemComNovosSchema = z.object({
  total: z.number(),
  /** Sempre >= 0: é uma contagem. `0` = ninguém nasceu, e a tela não diz nada. */
  novos: z.number(),
})

export const resumoSchema = z.object({
  apurado_em: z.string(),
  fuso: z.string(),
  agentes: contagemComNovosSchema,
  workflows: contagemComNovosSchema,
  execucoes_hoje: contagemSchema,
  recentes: z.array(execucaoRecenteSchema),
  mais_usados: z.array(agenteMaisUsadoSchema),
})

export type Resumo = z.infer<typeof resumoSchema>
export type ExecucaoRecente = z.infer<typeof execucaoRecenteSchema>
export type AgenteMaisUsado = z.infer<typeof agenteMaisUsadoSchema>
export type Contagem = z.infer<typeof contagemSchema>
export type ContagemComNovos = z.infer<typeof contagemComNovosSchema>
